import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import { useTranslation } from "react-i18next";
import { useCallback, useContext, useEffect, useState } from "react";
import { Form } from "antd";
import { GlobalContext } from "../../../../context/GlobalContext";
import HelpSection from "../../../Common/HelpSection/HelpSection";
import { fileToBase64 } from "../../../Util/FiletoBase64";
import './RedownloadAttachments.scss';
import CommentField from "./CommentField";
import { updateCreateOpportunityCombined } from "../../../../api/apigeeApi";
import { UpdateExistingCustomerFinalRes } from "../../../Util/UpdateExistingCustomerFinalRes";
import { UpdateNewCustomerFinalRes } from "../../../Util/UpdateNewCustomerFinalRes";
import { leadDetails } from "../../../../api/api";
import { useUploadJson } from "../../uploadJson";
import ReUploadDocument from "./ReUploadDocument";

const win: any = window;

function DownloadReuploadSection({ rtl }: any) {
  const dir = rtl ? "right" : "left";
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [state, dispatch]: any = useContext(GlobalContext);
  const uploadJson = useUploadJson();
  const { userType, setQueryData } = state;
  const [waitingForUpdate, setWaitingForUpdate] = useState(false);
  const [downloadDetails, setDownloadDetails] = useState<any>([]);
  const maxLength = 500;
  const [comment, setComment] = useState<string>("")
  const [isNextEnabled, setIsNextEnabled] = useState(false);

  const getFormattedDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  };
  const currentDateTime = new Date().toISOString()
  const currentDate = getFormattedDateTime();

  const filterDataFn = useCallback(() => {
    const emptyNew = setQueryData.ptype !== 'Voice' || setQueryData.otype === "new" || setQueryData.otype === "both"
    const foundMNP = setQueryData.otype === "transfer" || setQueryData.otype === "both"

    let filterData = uploadJson.filter((item: any) =>
      item.userType.includes(state.userType) && (item.productType.length === 0 || item.productType.includes(state.productType))
    );

    if (!foundMNP) {
      filterData = filterData.filter(
        (item: any) =>
          item.title !== t("Transfer_Mobily_Document") && item.title !== t("CST_Consent_form_title")
      );
    }
    if (!emptyNew) {
      filterData = filterData.filter(
        (item: any) =>
          item.title !== t("Enduser_title")
      );
    }
    setDownloadDetails(filterData)
  }, [state.userType, state.productType]);

  useEffect(() => {
    filterDataFn();
  }, [state.userType, state.productType]);

  useEffect(() => {
    const atLeastOneUploaded = downloadDetails.some((item: any) => item.fileSelected);
    setIsNextEnabled(atLeastOneUploaded);
  }, [downloadDetails]);

  const initialValues = {

  }

  const callbackFunction = async (updateFinalResponse: any) => {
    const requestBody = {
      lead_id: setQueryData.extid, customer_type: setQueryData.ctype, package_type: setQueryData.ptype, identifer: setQueryData.unqid, created_date: ""
    };
    try {
      dispatch({ type: 'LOADER', payload: { loading: true } });
      const finalRes = await updateCreateOpportunityCombined(updateFinalResponse);
      dispatch({ type: 'LOADER', payload: { loading: true } });
      if (finalRes.status === 200) {
        const res = await leadDetails(requestBody);
        if (res.status === 200) {
          window.location = win['submit_order_thanku_url'];
        } else {
          dispatch({ type: 'ERROR_PAGE', payload: { page: t("Failed_to_submit") } });
          document.location.href = "/wps/portal/web/personal/store/error";
        }
      } else {
        dispatch({ type: 'ERROR_PAGE', payload: { page: t("Failed_to_submit") } });
        document.location.href = "/wps/portal/web/personal/store/error";
      }
    } catch (error) {
      dispatch({ type: 'LOADER', payload: { loading: true } });
      dispatch({ type: 'ERROR_PAGE', payload: { page: t("Something_went_wrong") } });
      document.location.href = "/wps/portal/web/personal/store/error";
    }
  }
  const fileConverter = async (file: HTMLInputElement | any) => {
    const fileBaseRaw = await fileToBase64(file);
    const fileBase64 = await fileBaseRaw.split(';base64,');
    return await fileBase64[1];
  };

  const selectFileHandler = async (e: any, selectedFile: any) => {
    if (selectedFile !== null) {
      let { name } = e;
      const nameLower = name.replace(/ /g, "").toLowerCase();

      const newState = [...downloadDetails];
      const index = newState.findIndex(
        (item) => item.title.replace(/ /g, "").toLowerCase() === nameLower
      );
      const updatedState = { ...newState[index] };

      updatedState.file = await fileConverter(selectedFile);
      updatedState.fileSelected = true;
      updatedState.value = form.getFieldValue(name);
      updatedState["type"] = selectedFile.type;
      newState[index] = updatedState;
      setDownloadDetails(newState);
    } else {
      let value = e.alt;
      value = value.replace(/ /g, "").toLowerCase();

      const updateDetails = [...downloadDetails];
      const index = updateDetails.findIndex(
        (item) => item.title.replace(/ /g, "").toLowerCase() === value
      );

      const updatedState = { ...updateDetails[index] };
      updatedState.file = {};
      updatedState.fileSelected = false;
      updatedState.value = "";
      updatedState.isInvalid = false;

      updateDetails[index] = updatedState;
      setDownloadDetails(updateDetails);
    }
  };

  const errorMessageHandler = (name: string, error: any) => {
    if (error && error !== '') {
      form.setFields([
        {
          name,
          value: '',
          errors: [error],
        },
      ]);
    }
  };
  const onChangeComment = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(e.target.value);
    form.setFieldsValue({ comment: e.target.value });
  };
  useEffect(() => {
    if (waitingForUpdate && state.isDownloadUpdated && state.isCommentUpdated) {
      const updateFinalResponse =
        state.userType === 'existingcustomer'
          ? UpdateExistingCustomerFinalRes(state)
          : UpdateNewCustomerFinalRes(state);
      callbackFunction(updateFinalResponse);
      dispatch({ type: 'RESET_UPDATE_FLAGS' });
      setWaitingForUpdate(false);
    }
  }, [waitingForUpdate, state.isDownloadUpdated, state.isCommentUpdated]);

  const handleClick = async () => {
    try {
      const fileDetails = downloadDetails
        .filter((item: any) => item.fileSelected)
        .map((item: any) => ({
          FileContentBinaryObject: item.file,
          Name: `${item.title} ${currentDate}`,
          PathName: `./${item.title}`,
          MIMECode: item.type === "" ? 'application/vnd.ms-outlook' : item.type,
          SystemAdministrativeData: {
            CreationDateTime: currentDateTime,
          },
          VisibleIndicator: "true",
          VersioningEnabledIndicator: "false",
          CategoryCode: "2",
          TypeCode: item.typeCode,
        }));

      dispatch({
        type: "RE_DOWNLOAD_ATTACHMENT_DATA",
        payload: { values: fileDetails, page: t("Download_Attach"), modalOpen: true },
      });

      const commentValue = form.getFieldValue('comment') || " ";
      dispatch({ type: "COMMENT_DATA", payload: { values: commentValue } });

      setWaitingForUpdate(true);
    } catch (error) {
      console.log(error);
      setDownloadDetails([...downloadDetails])
    }
  };


  return (
    <Form form={form} name="accordionForm" initialValues={initialValues} className="d-flex flex-column">
      <div className={`download-upload-section du-${dir}`}>
        <div className='ProductInformation__headerSection flex-column-reverse-mobile'>
          <div className={`product-information-text-container text-container-${dir} col-sm-8`}>
            <Typography rtl={rtl} className="form-title">{t("Download_Attach")}</Typography>
            <Typography rtl={rtl} className="product-information-text">{t("Document_Required")}</Typography>
          </div>
          <HelpSection rtl={rtl} />
        </div>
        {downloadDetails.map((item: any, index: any) => {
          console.log(form.getFieldError(item.title))
          return (
            <ReUploadDocument
              key={index}
              rtl={item.rtl}
              downloadForm={item.downloadForm}
              title={item.title}
              subTitle={item.subTitle}
              uploadFileText={item.uploadFileText}
              toolTipText={item.toolTipText}
              downloadFileSrc={item.downloadFileSrc}
              sizeErrorText={item.sizeErrorText}
              fileTypeErrorText={item.fileTypeErrorText}
              selectFileHandler={selectFileHandler}
              errorMessageHandler={errorMessageHandler}
              selectFileError={item.selectFileError}
              fileType={item.fileType}
              userType={item.userType}
              name={item.title}
              fileSupportPlaceholder={item.fileSupportPlaceholder || `${t('Supports_Files')}`}
              selectFileErrorText={form.getFieldError(item.title).join(' ')}
              rules={[]}
            // rules={[
            //   { required: true, message: t('selectFileErrorText') }
            // ]}
            />
          );
        })}
      </div>
      <div className={`upload-attachment-container text-${dir} col-sm-7`}>
        <CommentField onChangeComment={onChangeComment} value={comment} maxLength={maxLength} />
      </div>
      <IconButton width={"140px"} htmlType='submit' rtl={rtl}
        onClick={handleClick} variant={!isNextEnabled ? "disabled" : "default"}>
        {t("Submit")}
      </IconButton>
    </Form>
  );
}

export default DownloadReuploadSection;
